import React from 'react'

function StickyBoxs() {
    return (
        <section className='section-sticky'>
            <div className='container-fluid'>
                <div className='col-md-11 mx-auto'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='section-heading sticky-content'>
                                <h2>Everything you need to simplify and scale your shipping</h2>
                                <p>From order management to delivery optimization, <b>ParcelX brings powerful logistics tools into one seamless platform.</b> Built for modern businesses, every feature is designed to help you ship faster, reduce costs, and deliver a better customer experience.</p>
                                <p>Whether you're a growing <b>D2C brand, marketplace seller, or enterprise business,</b> ParcelX empowers you to optimize operations, improve delivery success rates, and scale effortlessly—while maintaining full visibility and control over your shipments. </p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='main-sticky-card'>
                                <div className='sticky-items'>
                                    <div className='left-box'>
                                        <h2>Smart Analytics</h2>
                                        <p>Get complete visibility into your shipments with real-time insights, performance tracking, and detailed reports to make smarter business decisions.</p>
                                    </div>
                                </div>
                                <div className='sticky-items sticky-items01'>
                                    <div className='right-box'>
                                        <h2>Courier Rate Comparison</h2>
                                        <p>Compare multiple courier partners in one place and choose the best option based on cost, delivery speed, and serviceability.</p>
                                    </div>
                                </div>
                                <div className='sticky-items sticky-items02'>
                                    <div className='left-box'>
                                        <h2>Real-Time Tracking</h2>
                                        <p>Keep your customers informed with live tracking updates and proactive notifications for every shipment.</p>
                                    </div>
                                </div>
                                <div className='sticky-items sticky-items03'>
                                    <div className='right-box'>
                                        <h2>Automated Order Management</h2>
                                        <p>Sync orders from multiple platforms, generate labels instantly, and manage shipments effortlessly with minimal manual work.</p>
                                    </div>
                                </div>
                                <div className='sticky-items sticky-items04'>
                                    <div className='left-box'>
                                        <h2>COD Remittance</h2>
                                        <p>Receive faster COD payments with reliable remittance cycles, helping you maintain smooth cash flow.</p>
                                    </div>
                                </div>
                                <div className='sticky-items sticky-items05'>
                                    <div className='right-box'>
                                        <h2>Multi-Channel Integration</h2>
                                        <p>Connect your Shopify, Amazon, and website stores to manage all orders from a single dashboard.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default StickyBoxs
